export const isDarkTheme = () => {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
};

export const setupThemeSwitching = (leafletMap, light, dark) => {
    const applyTheme = () => {
        if (leafletMap.hasLayer(light)) leafletMap.removeLayer(light);
        if (leafletMap.hasLayer(dark)) leafletMap.removeLayer(dark);
        if (isDarkTheme()) {
            dark.addTo(leafletMap);
        } else {
            light.addTo(leafletMap);
        }
    };
    applyTheme();
    if (!window.matchMedia) return () => {};
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    query.addEventListener('change', applyTheme);
    return () => query.removeEventListener('change', applyTheme);
};

export const CARTO_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';

const readCartoBasemapKey = () => {
    const meta = document.querySelector('meta[name="carto-basemap-key"]');
    return meta ? (meta.getAttribute('content') || '').trim() : '';
};

export const cartoTileUrl = (style) => {
    const key = readCartoBasemapKey();
    const url = 'https://{s}.basemaps.cartocdn.com/' + style + '/{z}/{x}/{y}{r}.png';
    return key ? url + '?key=' + encodeURIComponent(key) : url;
};
